// src/services/activityTypes.ts
import { apiJson } from './http';

export type ActivityTypeDTO = {
  id: number;
  code: string;
  label: string;
  icon?: string | null;
  active: boolean;
  defaultDurationMinutes?: number | null;
  defaultCost?: number | null; // number per il FE; il BE accetta BigDecimal
};

export async function listActivityTypes(active?: boolean): Promise<ActivityTypeDTO[]> {
  const q = active === undefined ? '' : `?active=${active}`;
  return apiJson<ActivityTypeDTO[]>(`/p/activity-types${q}`);
}

export async function getActivityType(id: number): Promise<ActivityTypeDTO> {
  return apiJson<ActivityTypeDTO>(`/p/activity-types/${id}`);
}

// opzionali (se la UI admin li usa)
export async function createActivityType(payload: ActivityTypeDTO): Promise<ActivityTypeDTO> {
  return apiJson<ActivityTypeDTO>(`/p/activity-types`, { method: 'POST', body: JSON.stringify(payload) });
}
export async function updateActivityType(id: number, payload: ActivityTypeDTO): Promise<ActivityTypeDTO> {
  return apiJson<ActivityTypeDTO>(`/p/activity-types/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
}
